import React, { useState } from 'react';
import AnalyticsFilters from '../components/filters/analyticsfilters';


import AppointmentsInsights from '../components/analytics/appointmentsinsights';
import RevenueInsights from '../components/analytics/revenueinsights';
import ClientsInsights from '../components/analytics/clientinsights';
import StaffDashboard from '../components/analytics/staffinsights';
import InventoryDashboard from '../components/analytics/inventoryinsights';
import SummaryKPIs from '../components/analytics/summarykpis';

const AnalyticsDashboard = () => {
  const getToday = () => {
    const t = new Date();
    const yyyy = t.getFullYear();
    const mm = String(t.getMonth() + 1).padStart(2, '0');
    const dd = String(t.getDate()).padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  };

  const [filters, setFilters] = useState({
    from: getToday(),
    to: getToday(),
    range: 'today'
  });
  

  return (
    
    <div className="analytics-dashboard flex flex-col space-y-6">
  

  <AnalyticsFilters filters={filters} setFilters={setFilters} />

  {/* Content just flows naturally */}
  <SummaryKPIs filters={filters} />
  <RevenueInsights filters={filters} />
  <AppointmentsInsights filters={filters} />
  <StaffDashboard filters={filters} />
  <ClientsInsights filters={filters} />
  <InventoryDashboard filters={filters} />
</div>

  );
};


export default AnalyticsDashboard;
